import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Form from 'react-bootstrap/Form';

const Input = forwardRef(function Input({
  variant = "primary",
  className,
  error = "",
  label,
  id,
  name,
  placeholder,
  type,
  disabled,
  value,
  isValidated = false,
  alwaysShowLabel = false,
  rightToLeft = false,
  fullWidth = false,
  ...other
}, ref) {
  if (["checkbox", "radio", "switch"].includes(type)) {
    return (
      <div key={`default-${type}`}>
        <Form.Check
          className={classNames(`custom-${type}-${variant}`, rightToLeft && "right-to-left", fullWidth && "fullwidth", className)}
          type={type}
          id={id || label}
          label={label}
          disabled={disabled}
          data-testid={type}
          name={name}
          value={value}
          {...other}
        />
      </div>
    );
  }

  return (
    <label
      htmlFor={label}
      className={classNames(
        "input-component",
        disabled && "disabled",
        error && "border-danger",
        className,
      )}
    >
      {label && (
        <span
          className={classNames(
            "input-label",
            (alwaysShowLabel || value) && "visible",
          )}
        >
          {label}
        </span>
      )}
      <input
        id={id || label}
        type={type}
        className={classNames(
          "position-relative",
          disabled && "disabled",
          error && "border-danger",
          isValidated && "validated",
        )}
        placeholder={placeholder || label || name}
        ref={ref}
        name={name}
        value={value}
        disabled={disabled}
        {...other}
      />
      <span
        className={classNames(
          "error",
          error && "visible",
        )}
      >
        {error || "no_error"}
      </span>
    </label>
  );
});

Input.propTypes = {
  variant: PropTypes.string,
  error: PropTypes.string,
  alwaysShowLabel: PropTypes.bool,
  isValidated: PropTypes.bool,
  rightToLeft: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default Input;
